export const SET_ORG_GROUPS = "SET_ORG_GROUPS";
export const SET_ORG_GROUP = "SET_ORG_GROUP";
export const SET_ORG_GROUP_GROUPS = "SET_ORG_GROUP_GROUPS";
export const SET_LOADING = "SET_LOADING";
export const SET_ORG_GROUP_SEARCH_VALUE = "SET_ORG_GROUP_SEARCH_VALUE";
export const SET_GROUP_LOCATIONS_FILTER_VALUE =
  "SET_GROUP_LOCATIONS_FILTER_VALUE";
export const SET_ORG_GROUP_NAME = "SET_ORG_GROUP_NAME";
export const SET_SEARCH_VALUE_ON_CLICK = "SET_SEARCH_VALUE_ON_CLICK";
export const RESET_ORG_GROUP = "RESET_ORG_GROUP";
